/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_StartInputs */

const cs_chat_new_start = /** @type {(inputs: Chat_New_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začít chat`)
};

const en_chat_new_start = /** @type {(inputs: Chat_New_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start chat`)
};

/**
* | output |
* | --- |
* | "Start chat" |
*
* @param {Chat_New_StartInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_start = /** @type {((inputs?: Chat_New_StartInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_StartInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_start(inputs)
	return cs_chat_new_start(inputs)
});